@if (downloadText) {
    <div>
        <span jhiTranslate="artemisApp.feedback.truncatedInfo"></span>
        <a [href]="downloadText" [download]="downloadFilename" jhiTranslate="artemisApp.feedback.downloadFullFeedback"></a>
    </div>
}
<br />
<div class="feedback-text">
    <p>{{ text }}</p>
</div>
